import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { ITeamMast, Table } from "./Table";
import { IPermissionProps } from "../../models/Login";
import { ITeamManagement } from "../../models/TeamManagement";
import { EmptyTeam, TeamData, teamData } from "./EmptyTeam";

export interface IModel {
    open: boolean,
    singleData: ITeamManagement,
    teamNameList: ITeamMast[]
}

export interface IModel2 {
    open: boolean,
    singleData: teamData
}

export interface IModel3 {
    open: boolean,
    singleData: teamData[],
    inTeam: teamData,
}

export const TeamMemberList = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptyTeam, open: false, teamNameList: [] } as IModel);
    const [modal2,setModal2] = useState({ singleData: TeamData, open: false } as IModel2);
    const [modal3,setModal3] = useState({ singleData: [], open: false, inTeam:{} } as IModel3);
    const [reload, setReload] = useState(false);
  
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyTeam, open: false, teamNameList: [] })
    };
    const hideDialog2 = () => {
        setModal2({ singleData: TeamData, open: false })
    };
    const hideDialog3 = () => {
        setModal3({ singleData: [], open: false, inTeam: TeamData })
    };

    return (
        <>
            <Table permissions={permissions} setModal={setModal} setModal2={setModal2} toast={toast} reload={reload} setReload={setReload}></Table>
            <Toast ref={toast} />
        </>
    );
}
